module.exports = __webpack_public_path__ + "static/background-hero-athletico-paranaense-md-fa3e6f96146324bc490d1103748b1f82.jpg";